
<template>
  <div>
    <base-card :option="cardOption">
      <div slot="cardBody">
        <search-form @setSearchCondition="setSearchCondition" @clearSearch="clearSearch"></search-form>
        <!--      操作按钮-->
        <div class="table-operator">
          <a-button style="margin-right: 10px" type="primary" icon="plus" @click="handleAdd">新增</a-button>
        </div>
        <!--表格-->
        <div class="table">
          <!-- <a-table
            :columns="table.columns"
            :rowKey="(record) => record.id"
            :dataSource="table.data"
            :pagination="pagination"
            :loading="table.loading"
            @change="handleTableChange"
            :rowSelection="rowSelection"
          >
            <template slot="actions" slot-scope="text, record">
              <a href="javascript:;" @click="() => handleView(record)">详情</a>
              <template>
                <a-divider type="vertical" />
                <a href="javascript:;" @click="() => handleEdit(record)">编辑</a>
              </template>
              <template>
                <a-divider type="vertical" />
                <a-popconfirm v-if="table.data.length" title="确定要删除吗?" @confirm="() => onDelete(record)">
                  <a href="javascript:;">删除</a>
                </a-popconfirm>
              </template>
            </template>
          </a-table> -->
          <zm-table
            :columns="table.columns"
            :rowKey="(record) => record.id"
            :dataSource="table.data"
            :pagination="pagination"
            :loading="table.loading"
            @change="handleTableChange"
            :rowSelection="rowSelection"
          >
            <template v-slot:actions="{ text, record }">
              <a href="javascript:;" @click="() => handleDetail(record)">详情</a>
              <template>
                <a-divider type="vertical" />
                <a href="javascript:;" @click="() => handleEdit(record)">编辑</a>
              </template>
              <template>
                <a-divider type="vertical" />
                <a href="javascript:;" @click="() => handleRecord(record)">询价记录</a>
              </template>
              <template>
                <a-divider type="vertical" />
                <a-popconfirm v-if="table.data.length" title="确定要删除吗?" @confirm="() => onDelete(record)">
                  <a href="javascript:;">删除</a>
                </a-popconfirm>
              </template>
            </template>
          </zm-table>
        </div>
      </div>
    </base-card>
    <!--各种弹出组件-->
    <edit-modal ref="editModal" @refreshTable="initTableData"></edit-modal>
    <record-list ref="recordList" @refreshTable="initTableData"></record-list>
    <import-modal ref="importModal" @refreshTable="initTableData"></import-modal>
    <detail-modal ref="detailModal"></detail-modal>
  </div>
</template>

<script>
import { getInquiryList, deleteInquiry } from '@/api/inquiry'
import editModal from './modules/editModal'
import searchForm from './modules/searchForm'
import baseCard from '@/CrComponents/Card/Card'
import importModal from './modules/importModal'
import detailModal from './modules/detailModal'
import RecordList from './modules/recordList.vue'
export default {
  name: 'inquiryList',
  mounted () {
    this.searchModel = { ...this.pagination }
    this.initTableData()
  },
  computed: {},
  components: {
    editModal,
    searchForm,
    baseCard,
    importModal,
    detailModal,
    RecordList
  },
  data () {
    return {
      // card相关属性设置
      cardOption: {},
      // 搜索form中的参数
      searchFormModel: {},
      // 所有搜索条件 包括分页，搜素框，表格上筛选条件
      searchModel: {},
      // 表格中的查询条件
      searchTableModel: {},
      // 高级搜索 展开/关闭
      searchInput: null,
      searchText: '',
      selectedRows: [],
      rowSelection: {
        selectedRowKeys: [],
        onChange: (selectedRowKeys, selectedRows) => {
          this.rowSelection.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {
          this.selectedRows = selectedRows
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
          this.selectedRows = selectedRows
        }
      },
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      table: {
        data: [
          { id: 1, name: '手机', number: 'shouji', spec: 'HUAWEI P50', unitDesc: '部' }
        ],
        config: {},
        columns: [
          {
            title: '产品编号',
            dataIndex: 'number',
            ellipsis: true,
            width: '25%'
          },
          {
            title: '产品名称',
            dataIndex: 'name',
            ellipsis: true,
            width: '23%'
          },
          {
            title: '规格型号',
            dataIndex: 'spec',
            width: '20%'
          },
          {
            title: '单位',
            dataIndex: 'unitDesc',
            width: '12%'
          },
          {
            title: '操作',
            // fixed: 'right',
            width: '20%',
            scopedSlots: {
              customRender: 'actions'
            }
          }
        ],
        searchCondition: {},
        loading: false,
        filteredInfo: null,
        sortedInfo: null
      }
    }
  },
  methods: {
    // 获取选中的table
    rowSelectChange (value) {
      this.selectedRows = value
    },
    // 导入
    handleImport () {
      this.$refs.importModal.setModel(this.model)
      this.$refs.importModal.open(true)
    },
    // 搜索
    setSearchCondition (searchFormModel) {
      this.searchFormModel = searchFormModel
      this.pagination.pageNum = 1
      this.pagination.current = 1
      this.searchModel = { ...this.pagination, ...this.searchTableModel, ...searchFormModel }
      this.initTableData()
    },
    // 重置
    clearSearch (searchFormModel) {
      this.pagination.pageNum = 1
      this.pagination.current = 1
      this.searchModel = { ...this.pagination, ...this.searchTableModel }
      this.initTableData()
    },
    // 表格中的搜索
    handleSearch (selectedKeys, confirm) {
      confirm()
      this.searchText = selectedKeys[0]
    },
    // 表格中的重置
    handleReset (clearFilters) {
      clearFilters()
      this.searchText = ''
    },
    // 初始化表格数据
    async initTableData () {
      this.selectedRows = []
      this.rowSelection.selectedRowKeys = []
      this.table.loading = true
      const res = await getInquiryList(this.searchModel).catch((err) => {
        console.log('初始化失败', err)
      })
      if (res && res.status === 0) {
        this.table.loading = false
        this.table.data = res.data.list
        this.pagination.total = res.data.total
      } else {
        this.$message.warning('获取数据失败！')
      }
    },
    // 切换页码等操作
    handleTableChange (pagination, filters, sorter) {
      this.pagination.pageSize = pagination.pageSize
      this.pagination.pageNum = pagination.current
      this.pagination.current = pagination.current
      this.searchModel = {
        ...this.searchModel,
        ...this.pagination
      }
      this.initTableData()
    },
    async deleteFn (ids) {
      const res = await deleteInquiry(ids).catch((err) => {
        console.log('初始化失败', err)
      })
      if (res && res.status === 0) {
        this.$message.success(res.info.message)
        this.initTableData()
      } else {
        this.$message.error(res.info.message)
      }
    },
    // 删除操作
    onDelete (model) {
      this.deleteFn(model.id)
    },
    // 查看详情
    handleDetail (model) {
      this.$refs.detailModal.setTitle('查看询价产品信息')
      this.$refs.detailModal.setModel(model) // 先设置类型，再打开
      this.$refs.detailModal.open(true)
    },
    // 询价记录
    handleRecord (model) {
      this.$refs.recordList.setTitle('询价记录')
      this.$refs.recordList.setModel(model) // 先设置类型，再打开
      this.$refs.recordList.open(true)
    },
    // 编辑
    handleEdit (model) {
      this.$refs.editModal.setTitle('编辑询价产品信息')
      this.$refs.editModal.setType(this.$sysInfo.MODAL_MODIFY)
      this.$refs.editModal.setModel(model) // 先设置类型，再打开
      this.$refs.editModal.open(true)
    },
    // 新增
    handleAdd () {
      this.$refs.editModal.setTitle('新增询价产品信息')
      this.$refs.editModal.setType(this.$sysInfo.MODAL_ADD) // 先设置类型，再打开
      this.$refs.editModal.open(true)
    },
    // 批量删除
    async batchDel () {
      const searchModel = this.selectedRows
      if (!searchModel || searchModel.length === 0) {
        this.$message.warning('请至少选择一行数据进行删除！')
        return
      }
      let params = ''
      searchModel.map((item) => {
        params += item.id + ','
      })
      params = params.substring(0, params.length - 1)
      this.deleteFn(params)
    }
  }
}
</script>

<style scoped  lang="less">
.listContent {
  .table {
    margin-top: 10px;
  }
}
</style>